<template>
<div class="chapter">
<div class="inner_page">
<p class="chaptitle"><b>ACKNOWLEDGEMENTS</b></p>
<p class="noindent">I would like to thank The History Press for giving me the opportunity to write my first book on a topic I have loved since I was a kid; Tom Maat, my partner in crime, for all of his help, support, driving, pictures and late-night “rumrunners” at the Tip; Jeanette Weiden in the local history/genealogy department and the rest of my helpful co-workers at Loutit District Library for helping me find old, forgotten information; Troy Taylor and Rosemary Ellen Guiley for inspiring me years ago with their wonderful books; Julie Williams for listening to me go on…and on and on; my buddy Jason Gowin for reminding me that if I didn’t do certain things, I “wouldn’t be Amber”; my friends and family for putting up with and supporting my crazy ghost-hunting ways; and lastly, Ghostly Talk Paranormal Radio out of Warren, Michigan, and its co-ghost and my better half, Scott Lambert, for their continued efforts to bring quality information to the paranormal world.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ack.vue?360c7f39